var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tee-slider',{attrs:{"position":_vm.$store.state.simulator.transitionState},on:{"change":_vm.checkTransStatus,"mousedown":function($event){return _vm.$store.commit('simulator/stopAuto')}}})}
var staticRenderFns = []

export { render, staticRenderFns }